import emit from '../../../common/events';
import { PaymentDetails, RmsBookstoreAddress } from '../../checkout/shop-checkout.interface';
import { StoreState } from '../../../store/store.interface';
import { getCartAnalyticsOverrides } from '../../cart/shop-cart/shop-cart.analytics';
import { getUserDataForUserAnalytics } from '../../user-profile/user-profile.selectors';

export class ApplePayButtonAnalytics {
  /**
   * Event to track when Apple Pay checkout is started.
   *
   * @param state
   * @param element
   * @param amount
   */
  startEvent(state: StoreState, element: Element, amount: string): void {
    emit({
      element,
      name: `mhecomm-apple-pay-checkout-start`,
      detail: {
        label: 'Apple Pay Checkout Start',
        url: window.location.href,
        user: getUserDataForUserAnalytics(state),
        orderTotal: parseFloat(amount),
        ...getCartAnalyticsOverrides(state),
      }
    });
  }

  /**
   * Event to track when Apple Pay checkout is completed.
   *
   * @param element
   * @param paymentDetails
   * @param billingAddress
   * @param shippingAddress
   */
  checkoutInfoCollected(
    element: Element,
    paymentDetails: PaymentDetails,
    billingAddress: RmsBookstoreAddress,
    shippingAddress: RmsBookstoreAddress | undefined
  ): void {
    emit({
      element,
      name: `mhecomm-apple-pay-checkout-info-collected`,
      detail: {
        billingAddress,
        paymentDetails,
        shippingAddress
      }
    });
  }
}
